import { FC } from 'react';
import { TopMenuItem } from 'dashboard409a/components';
import { ListContainer, RootContainer } from './styles';
import { ITopMenu } from './types';

const TopMenu: FC<ITopMenu> = props => {
  const { items } = props;

  return (
    <RootContainer>
      {items.length > 0 && (
        <ListContainer>
          {items.map(menuItem => (
            <TopMenuItem item={menuItem} key={menuItem.slug} />
          ))}
        </ListContainer>
      )}
    </RootContainer>
  );
};

export default TopMenu;
